<template>
  <ul class="w-full cursor-default">
    <li class="px-4 text-black hover:bg-gray-200">
      <button type="button" @click="deleteOptionRecipeButton">
        Remove Recipe
      </button>
    </li>
    <li class="px-4 text-black hover:bg-gray-200">
      <button type="button" @click="replaceOptionRecipe">
        Replace Recipe
      </button>
    </li>

    <li class="px-4 text-black hover:bg-gray-200 is_hide_production">
      <span v-if="checkExistTag(mc_option_recipe, default_tag)" class="w-full block cursor-pointer"
        @click="attachRecipeToDefaultTag">Send to
        {{
        default_tag.name
        }}</span>

      <span v-else class="w-full block cursor-pointer" @click="detachRecipeToDefaultTag">Remove
        to {{ default_tag.name }} </span>
    </li>

    <li v-if="element.tags && element.tags.length > 0" v-for="(tag, tagIndex) in element.tags" :key="tagIndex"
      class="px-4 text-black hover:bg-gray-200 is_hide_production" v-show="$page.props.default_tag != tag.name.toLowerCase()">
      <span v-if="$page.props.default_tag == tag.name.toLowerCase()" class="w-full block">{{ tag.name }}</span>

      <span v-else-if="checkExistTag(mc_option_recipe, tag)" class="w-full block cursor-pointer"
        @click="attachRecipeToTag(mc_option_recipe, tag)">Send to {{ tag.name }}</span>

      <span v-else class="w-full block cursor-pointer" @click="detachRecipeToTag(mc_option_recipe, tag)">Remove
        to {{ tag.name }}</span>
    </li>
  </ul>

</template>
<script>
  import vClickOutside from "click-outside-vue3";
  export default {
    directives: {
      clickOutside: vClickOutside.directive
    },

    props: ['mc_option_recipe', 'default_tag', 'element'],

    components: { vClickOutside },

    data() {
      return {
        is_show: 0
      };
    },

    methods: {
      onClickOutside() {
        this.is_show = 0;
      },
      deleteOptionRecipeButton() {
        this.$emit('deleteOptionRecipeButton');
      },
      replaceOptionRecipe() {
        this.$emit('replaceOptionRecipe');
      },

      attachRecipeToDefaultTag() {
        this.$emit('attachRecipeToDefaultTag');
      },
      detachRecipeToDefaultTag() {
        this.$emit('detachRecipeToDefaultTag');
      },
      attachRecipeToTag(mc_option_recipe, tag) {
        this.$emit('attachRecipeToTag', mc_option_recipe, tag);
      },
      detachRecipeToTag(mc_option_recipe, tag) {
        this.$emit('detachRecipeToTag', mc_option_recipe, tag);
      },
      checkExistTag(element, tagData) {
        if (!element.tags) {
          return true;
        }
        return !element.tags.some(tag => tag.name.toLowerCase() === tagData.name.toLowerCase());
      },
    },
  };
</script>